import { InputMask } from 'primereact/inputmask'
import { InputText } from 'primereact/inputtext'
import PropTypes from 'prop-types'
import React from 'react'
import { FormFeedback, FormGroup, Label } from 'reactstrap'

export default function CustomNumberFormat({
  onChange,
  name,
  label,
  value,
  type,
  placeholder,
  autoComplete,
  readOnly,
  invalid,
  errorMess,
  className,
  disabled,
  formClassName,
  isNumericString,
  format,
  size,
  onClickFunction,
  hidePhoneIcon,
  customIcon,
}) {
  return (
    <>
      {name.toLowerCase().includes('email') ? (
        <>
          {label ? <Label>{label}</Label> : null}
          <div className='p-inputgroup'>
            <span
              className='p-inputgroup-addon customInputWithIcon customInputWithIcon--email'
              onClick={onClickFunction}
            >
              <i className={`pi ${customIcon}`}></i>
            </span>
            <InputText
              className={`${className} p-inputtext-sm`}
              name={name}
              value={value}
              placeholder={placeholder}
              onChange={onChange}
              disabled={disabled}
            />
          </div>
        </>
      ) : (
        <FormGroup className={formClassName}>
          {label ? <Label>{label}</Label> : null}
          <div>
            <div className='p-inputgroup p-inputgroup-sm'>
              {!hidePhoneIcon && (
                <span className='p-inputgroup-addon customInputWithIcon'>
                  <i className={`fas ${customIcon || 'fa-phone'} customIconForInput`} onClick={onClickFunction}></i>
                </span>
              )}

              <InputMask
                className={`${className} p-inputtext-sm`}
                onChange={onChange}
                name={name}
                readOnly={readOnly}
                value={value}
                type={type}
                placeholder={placeholder}
                autoComplete={autoComplete}
                invalid={invalid}
                disabled={disabled}
                isNumericString={isNumericString}
                mask={format}
                size={size}
              />
            </div>
          </div>

          <FormFeedback style={{ marginBottom: '-20px' }}>{errorMess}</FormFeedback>
        </FormGroup>
      )}
    </>
  )
}

CustomNumberFormat.propTypes = {
  label: PropTypes.string,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  invalid: PropTypes.bool,
  removeLabel: PropTypes.bool,
  autoComplete: PropTypes.string,
  errorMess: PropTypes.string,
  className: PropTypes.string,
  isNumericString: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  hidePhoneIcon: PropTypes.bool,
}

CustomNumberFormat.defaultProps = {
  readOnly: false,
  hidePhoneIcon: false,
}
